import { GridColDef } from '@mui/x-data-grid-pro';
// import StatusCell from './components/StatusCell';
import ActionsCell from './components/ActionsCell';
import AdvertisersCell from './components/AdvertisersCell';
import AgencyNameCell from './components/AgencyNameCell';
import ClientCell from './components/ClientCell';

const COLUMNS: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Agency Name',
    display: 'flex',
    renderCell: AgencyNameCell,
    flex: 2,
  },
  {
    field: 'client',
    headerName: 'Client',
    display: 'flex',
    renderCell: ClientCell,
    align: 'center',
    headerAlign: 'center',
    flex: 1,
    sortable: false,
  },
  {
    field: 'advertisers',
    headerName: 'Advertisers',
    display: 'flex',
    renderCell: AdvertisersCell,
    align: 'center',
    headerAlign: 'center',
    flex: 2.5,
    sortable: false,
  },
  // {
  //   field: 'status',
  //   headerName: 'Status',
  //   display: 'flex',
  //   renderCell: StatusCell,
  //   align: 'center',
  //   headerAlign: 'center',
  //   flex: 1,
  //   sortable: false,
  // },
  {
    field: 'actions',
    flex: 1,
    headerName: 'Actions',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    renderCell: ActionsCell,
    sortable: false,
  },
];

export default COLUMNS;
